import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    "@global": {
        ".docuiSearchDateRangeWrapper.rdrDateRangeWrapper": {
            width: 632,
            boxShadow: "0px 8px 16px 1px rgba(0, 0, 0, 0.04)",
            borderRadius: 4,
            overflow: "hidden",
            fontFamily: "Montserrat, sans-serif"
        },
        ".docuiSearchDateRangeWrapper .rdrMonths": {
            width: 632
        },
        ".docuiSearchDateRangeWrapper .rdrMonth": {
            width: 316,
            padding: "0 16px 8px",
            boxSizing: "border-box"
        },
        ".docuiSearchDateRangeWrapper .rdrMonthAndYearWrapper": {
            height: 50,
            padding: "12px 0",
            margin: 0
        },
        ".docuiSearchDateRangeWrapper .rdrMonthAndYearPickers select": {
            fontSize: 14,
            lineHeight: "12px",
            color: "#3A3A42",
            fontFamily: "Montserrat, sans-serif"
        },
        ".docuiSearchDateRangeWrapper .rdrWeekDays": {
            borderBottom: "1px solid #EBEBF0"
        },
        ".docuiSearchDateRangeWrapper .rdrWeekDay": {
            color: "#3A3A42",
            fontSize: 12,
            fontWeight: 600,
            lineHeight: "10px",
            fontFamily: "Montserrat, sans-serif"
        },
        ".docuiSearchDateRangeWrapper .rdrDayNumber span": {
            color: "#0F0F19",
            fontSize: 12,
            fontFamily: "Montserrat, sans-serif"
        },
        ".docuiSearchDateRangeWrapper .rdrDayToday .rdrDayNumber span:after": {
            display: "none"
        },
        ".docuiSearchDateRangeWrapper .rdrStartEdge, .docuiSearchDateRangeWrapper .rdrEndEdge, .docuiSearchDateRangeWrapper .rdrInRange": {
            color: "#0080AF"
        },
        ".docuiSearchDateRangeWrapper .rdrSelected, .docuiSearchDateRangeWrapper .rdrDayStartPreview, .docuiSearchDateRangeWrapper .rdrDayEndPreview, .docuiSearchDateRangeWrapper .rdrDayInPreview": {
            borderColor: "#0080AF"
        },
        ".docuiSearchDateRangeWrapper .rdrDayPassive .rdrDayNumber span": {
            color: "#D5D5DD"
        }
    },
    paper: {
        width: "45%",
        color: theme.secondaryColor,
        background: theme.primaryColor
    },
    input: {
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        flex: 1
    },
    backdropFull: {
        width: "100%",
        height: "100%",
        position: "absolute",
        color: "primary",
        zIndex: 100000
    },      
    tableWrapper: {
        width: "100%",
        maxHeight: "70vh",
        overflow: "auto",
        fontFamily: "courier",
        padding: "20px 20px 60px 10px",
        marginLeft: '15px',
        marginRight: '15px',
    },
    box: {
        padding: "20px 20px 60px 10px",
        marginLeft: '15px',
        marginRight: '15px',
        background: "#f8f8f8",
        overflow: "auto",
        marginBottom: "20px",
    },
    tableBorder: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        display: "flex",
        flexDirection: "row"
    },
    tabStyling: {
        "&:hover": {
            background: '#E5E7E9'
        },
        fontWeight: 'bold'
    },
    tableBorder1: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        border: "0.8px solid #00000021",
        paddingBottom: theme.spacing(2),
    },
    listBorder: {
        border: "0.8px solid #00000021"
    },
    tableColumn: {
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: '0.95rem',
    },
    tableValueList: {
        textAlign: 'center',
        fontSize: '0.85rem',
    },
    table: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        border: "0.8px solid #00000021",
        marginBottom: theme.spacing(2),
    },
    tabHeading: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    formContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-end",
        paddingRight: theme.spacing(4)
    },

    hiddenField: {
        visibility: "hidden",
        padding: "20px",
        maxHeight: theme.spacing(3)
    },
    fileUploadWrapper: {
        background: "#f8f8f8",
        display: "flex",
        alignItems: "center",
        borderRadius: "5px",
    },
    fileCriteriaLabel: {
        display: "flex",
        justifyContent: "space-between"
    },
    tableTitleDiv: {
        display: "flex",
        paddingLeft: "15px",
        paddingRight: "15px",
        marginLeft: theme.spacing(1.6),
        flexDirection: 'row',
        fontFamily: 'Times New Roman'
    },
    tableTitleDiv2: {
        display: "flex",
        paddingLeft: "15px",
        paddingRight: "15px",
        marginLeft: theme.spacing(1.6),
        marginRight: theme.spacing(1.6),
        flexDirection: 'row',
        fontFamily: 'Times New Roman',
        borderTop: "5px solid #173a64",
    },
    tableTitle: {
        display: "flex",
    },
    backIcon: {
        marginTop: "20px",
        marginRight: theme.spacing(1),
    },
    tableHeadRight: {
        float: "right",
        display: "flex",
        justifyContent: "flex-end",
        width: "100%"
    },
    tableHead: {
        backgroundColor: "9E9E9E"
    },
    root: {
        width: "100%",
        background: "white",
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(4),
    },

    paper_root: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '5px',
    },
    boxDetails: {
        background: "#f8f8f8",
        marginTop: "50px",
        marginLeft: '15px',
        marginRight: '15px',
        wordBreak: "break-all",
    },
    submitButtonDiv: {
        minHeight: "5vh",
        paddingLeft: "1rem",
        minWidth: '7vw'
    },
    submitFilterButton: {
        marginRight: "1rem",
        float: "right",
    },
    formControl: {
        paddingRight: "0.5rem",
        minWidth: 200,
        maxWidth: 250,
        marginTop: theme.spacing(5),
        paddingBottom: '0px',
    },
    detailsDiv2: {
        minWidth: '45vw',
        maxWidth: '50vw',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
    },
    detailsDiv: {
        minWidth: '55vw',
        maxWidth: '55vw',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
    },
    detailsDiv1: {
        minWidth: '35vw',
        maxWidth: '35vw',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
    },
    smallTextIcon: {

    },
    detailsDivSpan: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    detailsLabel: {
        fontWeight: 'bold',
        padding: theme.spacing(0.5),
        fontSize: '0.95rem',
    },
    detailsValue: {
        paddingTop: theme.spacing(1),
        fontSize: '0.95rem',
    },
    detailsLogs: {
        fontWeight: 'bold',
        padding: theme.spacing(3),
        paddingTop: '0px'
    },
    inputBox: {
        // marginTop: theme.spacing(),
        marginLeft: theme.spacing(2),
        width: theme.spacing(42),
        marginRight: theme.spacing(3),
        // borderColor: 'black',
    },
    inputBox2: {
        // marginTop: theme.spacing(),
        marginLeft: theme.spacing(15),
        width: theme.spacing(30),
        marginRight: theme.spacing(13),
        // borderColor: 'black',
    },
    errorText: {
        display: 'flex',
        float: "left",
        // flexDirection: 'column',
        padding: theme.spacing(3),
        color: 'red',
        fontWeight: 'bold',
        paddingBottom: '2px',
    },
    labelRoot: {
        fontSize: 16,
        "&$labelFocused": {
            fontSize: 16,
        }
    },
    labelFocused: {},
    latestLicenseHeading: {
        paddingLeft: theme.spacing(2),
        paddingTop: "0px",
        paddingRight: theme.spacing(2),
    },
    mainTabText: {
        padding: theme.spacing(2),
        textAlign: 'center',
        fontSize: '0.95rem'
    },
    tableRow: {
        "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: "#E4E7E9"
        }
    },
    searchIcon: {
        marginTop: theme.spacing(1),
    },
    searchBox: {
        borderBottom: "0.8px solid #00000021",
        display: 'flex',
        height: theme.spacing(5),
        borderWidth: theme.spacing(8),
    },
    tableHeadRight: {
        display: "flex",
        justifyContent: "flex-end",
        width: "80%"
    },
    tasksPanelDiv: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1.5)
    },
    treeViewCollapsableTabs: {
        background: "#ffffff",
        border: "0.5px solid #00000021",
        fontWeight: "bold",
        borderRadius: "2px",
        boxShadow: "2px 2px 10px -5px",
        height: theme.spacing(10)
    },
    taskPanelLabel: {
        fontWeight: "bold",
        fontSize: theme.spacing(2.5)
    },
    tableProp: {
        background: "#f8f8f8",
    },
    refreshTaskBtn: {
        float: "right",
        marginTop: "15px",
        marginBottom: "15px",
        marginRight: "15px",
        paddingLeft: "5px",
        paddingRight: "5px"
    },
    tableContainer: {
        padding: "20px",
        paddingTop: "30px"
    },
    tableBorder2: {
        border: "0.8px solid #00000021",
    },
    tableHeadRow: {
        fontWeight: "700"
    },
    tableContainer: {
        padding: "20px",
        paddingTop: "30px"
    },
    tableFooterDiv: {
        display: "flex"
    },
    tableFooterNoteDiv: {
        width: "100%",
        paddingLeft: "1.5rem",
        marginTop: "0.25rem"
    },
    tablePaginationDiv: {
        marginTop: "-0.75rem",
        width: "100%",
        justifyContent: "flex-end",
        marginRight: theme.spacing(1),
    },
    taskTablePaginationDiv: {
        marginTop: "0.25rem",
        width: "100%",
        justifyContent: "flex-end",
        marginRight: theme.spacing(1),
    },
    noRecordsRow: {
        background: "#ffffff"
    },
    dividerStyling: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    dialogTitleX: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
    },
    dialogButtonX: {
        padding: '0px',
    },
    detailsDivDialog: {
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
        maxWidth: '45rem'
    },
    detailsDivSpan: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    detailsLabelDialog: {
        fontWeight: 'bold',
        paddingTop: theme.spacing(0.5),
        // paddingRight: '0.5px',
        fontSize: '0.95rem',
    },
    retryButtonDiv: {
        marginTop: "1rem",
        marginLeft: "0.5rem"
    },
    resubmitButton: {
        marginLeft: "1rem",
        float: "left",
    },
    dialogBoxDetailDiv: {
        display: 'flex',
        padding: theme.spacing(3),
        justifyContent: 'space-between'
    },
    dialogDispatcherDetailDiv: {
        display: 'block',
        // minWidth: '38rem'
    },
    detailsLogsDialog: {
        fontWeight: 'bold',
        paddingTop: '0px',
        paddingBottom: '1px',
        fontSize: '0.95rem',
    },
    box1: {
        display: "block",
        border: "1px solid #C6C6C6",
        marginTop: '15px',
        marginRight: '15px',
        marginBottom: '1.5rem',
        wordBreak: "break-all",
        minHeight: '60vh',
        maxHeight: '60vh',
        paddingBottom: '5px',
        overflow: 'scroll',
        minWidth: '70rem'
    },
    box2: {
        display: "block",
        border: "1px solid #C6C6C6",
        marginTop: '15px',
        marginRight: '15px',
        marginBottom: '1.5rem',
        wordBreak: "break-all",
        minHeight: '60vh',
        maxHeight: '60vh',
        paddingBottom: '5px',
        overflow: 'scroll',
        minWidth: '38rem',
        maxWidth: '38rem'
    },
    replicatorPayloadDiv: {
        marginTop: "1rem"
    },
    root_2: {
        width: "100%",
        background: "#F5F3F5",
        padding: theme.spacing(2),
        minHeight: "calc(100vh - 64px)"
    },
    backButton:{
        padding: 0,
        minWidth: 'auto',
        fontSize: '0.95rem',
        textTransform: 'none',
        fontWeight: 600,
        marginBottom: '4px'
    },

    searchPageRoot: {
        marginTop: 9,
        minHeight: "calc(100vh - 64px)",
        maxWidth: "90vw",
        overflowX: "hidden",
        background: "transparent",
        padding: theme.spacing(2, 0)
    },
    searchShell: {
        width: "100%",
        border: "1px solid #0080AF",
        borderRadius: 8,
        background: "#F9FCFF",
        boxShadow: "none",
        overflow: "hidden"
    },
    searchHeaderRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: 44,
        padding: "12px 24px 8px"
    },
    searchHeaderTitle: {
        display: "flex",
        alignItems: "center",
        gap: 12
    },
    searchHeaderActions: {
        display: "flex",
        alignItems: "center",
        gap: 8
    },
    searchTitle: {
        fontWeight: 700,
        fontSize: 24,
        lineHeight: "29px",
        color: "#0F0F19"
    },
    summarySearchTitle: {
        fontWeight: 700,
        fontSize: 16,
        lineHeight: "20px",
        color: "#0F0F19"
    },
    filterChip: {
        height: 24,
        background: "#FFFFFF",
        border: "1px solid #D5D5DD",
        color: "#6E6E72",
        borderRadius: 4,
        fontWeight: 400,
        "& .MuiChip-label": {
            fontSize: 14,
            lineHeight: "12px",
            padding: "0 8px"
        }
    },
    searchHeaderIcon: {
        width: 44,
        height: 44,
        borderRadius: 24,
        color: "#00445D",
        padding: 12
    },
    searchFieldsContainer: {
        border: "none",
        borderRadius: 0,
        background: "#F9FCFF",
        margin: 0,
        padding: "12px 24px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 16
    },
    defaultFieldsContainer: {
        boxSizing: "border-box",
        background: "#E3F2FD",
        border: "1px solid #99CCDF",
        borderRadius: 8,
        padding: 12,
        minHeight: 68
    },
    systemTextField: {
        "& .MuiOutlinedInput-root": {
            height: 32,
            background: "#FFFFFF",
            borderRadius: 4,
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0E6A8C",
                borderWidth: 2
            }
        },
        "& .MuiOutlinedInput-input": {
            padding: "8px",
            fontSize: 14,
            lineHeight: "12px",
            color: "#6E6E72"
        },
        "& .MuiOutlinedInput-input::placeholder": {
            color: "#6E6E72",
            opacity: 1
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#B6B6B9"
        }
    },
    systemFieldWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 4
    },
    systemFieldTopLabel: {
        fontSize: 11,
        lineHeight: "10px",
        color: "#6E6E72",
        fontWeight: 400,
        minHeight: 10,
        display: "block"
    },
    uploadDateTextField: {
        "& .MuiOutlinedInput-input": {
            cursor: "pointer"
        },
        "& .MuiOutlinedInput-input::placeholder": {
            color: "#6E6E72",
            opacity: 1
        }
    },
    documentNameTextField: {
        "& .MuiOutlinedInput-input::placeholder": {
            color: "#6E6E72",
            opacity: 1
        }
    },
    documentNameAdornment: {
        display: "flex",
        alignItems: "center",
        gap: 2
    },
    documentNameClearButton: {
        padding: 2
    },
    documentNameClearIcon: {
        fontSize: 18,
        color: "#6E6E72"
    },
    documentNameIcon: {
        fontSize: 18,
        color: "#6E6E72"
    },
    documentNamePopoverPaper: {
        minWidth: 360,
        maxWidth: 420,
        borderRadius: 4,
        border: "1px solid #D5D5DD",
        boxShadow: "0px 8px 16px 1px rgba(0, 0, 0, 0.08)",
        overflow: "hidden"
    },
    documentNamePopoverContainer: {
        background: "#FFFFFF",
        maxHeight: 220,
        overflowY: "auto"
    },
    documentNameRecentTitle: {
        padding: "14px 14px 6px",
        fontSize: 11.25,
        lineHeight: "18px",
        color: "#6E6E72",
        fontWeight: 500
    },
    documentNameRecentRow: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 12px",
        cursor: "pointer",
        "&:hover": {
            background: "#F5F7FA"
        }
    },
    documentNameRecentIcon: {
        fontSize: 24,
        color: "#6E6E72"
    },
    documentNameOptionRow: {
        padding: "10px 12px",
        cursor: "pointer",
        borderBottom: "1px solid #EBEBF0",
        "&:last-child": {
            borderBottom: "none"
        },
        "&:hover": {
            background: "#F5F7FA"
        }
    },
    documentNameOptionLabel: {
        fontSize: 17,
        lineHeight: "20px",
        color: "#00445D",
        fontWeight: 500
    },
    documentNameEmptyState: {
        padding: "12px",
        fontSize: 14,
        color: "#6E6E72"
    },
    uploadedByTextField: {
        "& .MuiOutlinedInput-input": {
            cursor: "pointer"
        },
        "& .MuiOutlinedInput-input::placeholder": {
            color: "#6E6E72",
            opacity: 1
        }
    },
    uploadedByIcon: {
        fontSize: 18,
        color: "#6E6E72"
    },
    uploadedByPopoverPaper: {
        width: 380,
        borderRadius: 8,
        boxShadow: "0px 8px 16px 1px rgba(0, 0, 0, 0.08)",
        border: "1px solid #D5D5DD",
        overflow: "hidden"
    },
    uploadedByPopoverContainer: {
        background: "#FFFFFF"
    },
    uploadedBySearchInput: {
        padding: 12,
        "& .MuiOutlinedInput-root": {
            height: 40,
            borderRadius: 4
        },
        "& .MuiOutlinedInput-input": {
            padding: "8px 12px",
            fontSize: 14,
            color: "#3A3A42"
        }
    },
    uploadedByOptionsList: {
        maxHeight: 260,
        overflowY: "auto"
    },
    uploadedByOptionRow: {
        display: "flex",
        alignItems: "center",
        padding: "8px 12px",
        cursor: "pointer",
        background: "#FFFFFF",
        "&:hover": {
            background: "#F5F7FA"
        }
    },
    uploadedByOptionSelected: {
        background: "#EDEDF1"
    },
    uploadedByOptionLabel: {
        fontSize: 16,
        lineHeight: "20px",
        color: "#0F0F19",
        fontWeight: 600
    },
    uploadedByEmptyState: {
        padding: "12px",
        fontSize: 14,
        color: "#6E6E72"
    },
    uploadDateIcon: {
        fontSize: 16,
        color: "#6E6E72"
    },
    documentTypeMenuPaper: {
        borderRadius: 8,
        border: "1px solid #D5D5DD",
        boxShadow: "0px 8px 16px 1px rgba(0, 0, 0, 0.08)",
        marginTop: 4
    },
    documentTypeMenuList: {
        paddingTop: 4,
        paddingBottom: 4
    },
    documentTypeMenuSearchItem: {
        minHeight: "auto",
        padding: "8px 12px",
        cursor: "default",
        "&:hover": {
            background: "#FFFFFF"
        }
    },
    documentTypeMenuSearchField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 6,
            background: "#FFFFFF"
        },
        "& .MuiOutlinedInput-input": {
            padding: "10px 12px",
            fontSize: 14,
            color: "#3A3A42"
        }
    },
    documentTypeMenuItem: {
        minHeight: 36,
        fontSize: 14,
        color: "#3A3A42",
        display: "flex",
        alignItems: "center",
        "&.Mui-selected": {
            backgroundColor: "#EEF7FB",
            color: "#00445D"
        },
        "&.Mui-selected:hover": {
            backgroundColor: "#E3F2FD"
        }
    },
    documentTypeMenuCheckbox: {
        padding: 0,
        marginRight: 12
    },
    uploadDatePopoverPaper: {
        boxShadow: "0px 8px 16px 1px rgba(0, 0, 0, 0.04)",
        borderRadius: 4,
        overflow: "hidden"
    },
    refineToggleRow: {
        display: "flex",
        alignItems: "center",
        gap: 4,
        minHeight: 44,
        marginTop: 0
    },
    refineToggleIconButton: {
        width: 44,
        height: 44,
        padding: 12,
        borderRadius: 24,
        color: "#00445D",
        "& .MuiSvgIcon-root": {
            fontSize: 20
        }
    },
    refineSectionBlock: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
        marginBottom: 8
    },
    refineToggleButton: {
        textTransform: "none",
        color: "#00445D",
        fontWeight: 700,
        padding: "10px 12px 10px 0",
        width: 114,
        minWidth: 114,
        minHeight: 44,
        fontSize: 14,
        lineHeight: "17px",
        borderRadius: 100
    },
    refineDivider: {
        flex: 1,
        background: "#99CCDF"
    },
    refineFieldsContainer: {
        marginTop: 0,
        border: "1px solid #99CCDF",
        borderRadius: 8,
        background: "#FFFFFF",
        padding: 12
    },
    refineTextField: {
        "& .MuiOutlinedInput-root": {
            height: 32,
            background: "#FFFFFF",
            borderRadius: 4
        },
        "& .MuiOutlinedInput-input": {
            padding: "8px",
            fontSize: 14,
            lineHeight: "12px",
            color: "#6E6E72"
        },
        "& .MuiOutlinedInput-input::placeholder": {
            color: "#6E6E72",
            opacity: 1
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#B6B6B9"
        }
    },
    searchActionBar: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 24,
        borderTop: "1px solid #0080AF",
        background: "#E3F2FD",
        borderRadius: "0 0 8px 8px",
        margin: 0,
        padding: "12px 24px",
        minHeight: 68
    },
    secondaryActionButton: {
        borderRadius: 100,
        textTransform: "capitalize",
        background: "#FFFFFF",
        border: "1px solid #00445D",
        borderColor: "#00445D",
        color: "#00445D",
        height: 44,
        minWidth: 133,
        padding: "10px 20px",
        fontWeight: 700,
        fontSize: 14,
        lineHeight: "17px",
        "& .MuiButton-startIcon": {
            marginRight: 8
        },
        "& .MuiSvgIcon-root": {
            color: "#00445D",
            fontSize: 20
        },
        "&:hover": {
            background: "#FFFFFF",
            borderColor: "#00445D"
        }
    },
    primaryActionButton: {
        borderRadius: 100,
        textTransform: "capitalize",
        background: "#00445D",
        color: "#FFFFFF",
        height: 44,
        minWidth: 142,
        padding: "8px 20px",
        fontWeight: 700,
        fontSize: 14,
        lineHeight: "17px",
        "&:hover": {
            background: "#00354A"
        },
        "&.Mui-disabled": {
            background: "#C7D7DE",
            color: "#6E6E72"
        }
    },
    resultsPageRoot: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 16
    },
    resultSearchSummary: {
        width: "100%",
        border: "1px solid #0080AF",
        borderRadius: 8,
        background: "#F9FCFF",
        minHeight: 56,
        padding: "8px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 8
    },
    resultSearchSummaryLeft: {
        display: "flex",
        alignItems: "center",
        gap: 12
    },
    resultSearchSummaryRight: {
        display: "flex",
        alignItems: "center",
        gap: 4
    },
    resetSearchLink: {
        textTransform: "none",
        color: "#00445D",
        fontWeight: 700,
        fontSize: 14,
        minWidth: "auto",
        padding: "4px 6px",
        "& .MuiButton-startIcon": {
            marginRight: 4
        },
        "& .MuiSvgIcon-root": {
            color: "#00445D",
            fontSize: 18
        },
        "&:hover": {
            background: "rgba(0, 128, 175, 0.08)"
        }
    },
    resetSearchDialogPaper: {
        width: 639,
        maxWidth: 639,
        borderRadius: 4,
        background: "#FFFFFF",
        boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.2)",
        overflow: "hidden"
    },
    resetSearchDialogHeader: {
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        boxSizing: "border-box",
        background: "#FFFFFF"
    },
    resetSearchDialogTitleWrap: {
        display: "flex",
        alignItems: "center",
        minHeight: 24,
        flex: 1
    },
    resetSearchDialogTitle: {
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: 20,
        lineHeight: "24px",
        color: "#0F0F19"
    },
    resetSearchDialogCloseButton: {
        width: 36,
        height: 36,
        borderRadius: 24,
        padding: 8,
        color: "#00445D",
        "& .MuiSvgIcon-root": {
            fontSize: 20
        }
    },
    resetSearchDialogContent: {
        minHeight: 88,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 12,
        padding: 16,
        boxSizing: "border-box",
        background: "#F9FCFF",
        border: "1px solid #99CCDF"
    },
    resetSearchDialogHint: {
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: 14,
        lineHeight: "12px",
        color: "#0F0F19"
    },
    resetSearchDialogMessage: {
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 12,
        lineHeight: "18px",
        color: "#0F0F19"
    },
    resetSearchDialogFooter: {
        height: 52,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 8,
        padding: "8px 16px",
        boxSizing: "border-box",
        background: "#FFFFFF",
        boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.12)"
    },
    resetSearchDialogSecondaryButton: {
        width: 160,
        minWidth: 160,
        height: 36,
        padding: "10px 16px",
        border: "1px solid #00445D",
        borderRadius: 100,
        textTransform: "capitalize",
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: 12,
        lineHeight: "14px",
        color: "#00445D",
        background: "#FFFFFF",
        "&:hover": {
            background: "#FFFFFF",
            borderColor: "#00445D"
        }
    },
    resetSearchDialogPrimaryButton: {
        width: 154,
        minWidth: 154,
        height: 36,
        padding: "10px 16px",
        borderRadius: 100,
        textTransform: "capitalize",
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: 12,
        lineHeight: "14px",
        color: "#FFFFFF",
        background: "#00445D",
        "&:hover": {
            background: "#00354A"
        }
    },
    searchSummaryToggleIcon: {
        color: "#2B4855",
        padding: 4
    },
    resultsHeader: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(1, 3)
    },
    resultsInfoText: {
        fontSize: 14,
        lineHeight: "12px",
        fontWeight: 500,
        color: "#3A3A42",
        marginTop: 4,
        marginBottom: 4
    },
    resultsGrid: {
        marginTop: theme.spacing(0.5)
    },
    resultsLeftPane: {
        height: "100%"
    },
    resultsRightPane: {
        height: "100%"
    },
    resultShell: {
        height: "100%",
        overflow: "auto",
        padding: "0px 28px 28px 28px",
        boxSizing: "border-box",
        borderRadius: 8,
        border: "1px solid #0080AF"
    },
    resultWhite: {
        background: "#FFFFFF"
    },
    resultZebra: {
        background: "#F9FCFF"
    },
    previewPane: {
        height: "100%",
        padding: 16,
        overflow: "auto",
        background: "#f8f8f8",
        borderRadius: 8
    },
    previewDocumentWrapper: {
        height: "100%",
        overflow: "auto",
        padding: 8,
        background: "#f5f5f5",
        borderRadius: 4,
        boxSizing: "border-box"
    }
}));
  
export default useStyles;